import { network } from './network';

export async function getCheckinStatus(opts) {
	const res = await network({
		url: `/api/v1/checkin/status`,
		method: 'post',
		params: {},
		headers: {
			'Token': opts.token,
			'App-Id': opts.appid
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function checkin(opts) {
	const res = await network({
		url: `/api/v1/checkin/check`,
		method: 'post',
		params: {
			id: opts.id
		},
		headers: {
			'Token': opts.token,
			'App-Id': opts.appid
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}